module.exports = __webpack_public_path__ + "img/Outfield-Suite.89ddc08f.jpg";